module.exports = __webpack_public_path__ + "static/media/linkedin.f7bd4b08.svg";